module.exports = __webpack_public_path__ + "static/media/shareresource.11b72516.svg";